import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=5b68649e&"
import script from "./Advertisement.controller.js?vue&type=script&lang=js&"
export * from "./Advertisement.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Advertisement.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "76dc3746"
  
)

export default component.exports